import React, { useState, useEffect } from "react";
import { Typography, Button, Divider } from "@mui/material";
import api from "../../../api/api";

import HistoryItem from "../components/HistoryItem";
import { Flame } from "lucide-react";
import Spinner from "../../layout/Spinner";
import { Link } from "react-router-dom";
import { ReactComponent as LinkIcon } from "../../../assets/icons/svg/link.svg";
import { getRecipeHistory } from "../../../actions/insights";

import { connect } from "react-redux";
import PropTypes from "prop-types";

export const RecipeHistory = ({
  date,
  getRecipeHistory,
  insights: { recipeHistory, recipeHistoryDate, recipeHistoryLoading, recipeHistoryError },
}) => {
  //IDEAS
  //Top chunk, show favourites? Planned meals? etc, in horizontal scroll
  //Top chunk show total cost?
  //Each meal section is a card, can add or plan meals in each

  useEffect(() => {
    if (date !== recipeHistoryDate) {
      getRecipeHistory(date);
    }
  }, [date]);

  const formatDate = (date) => {
    const now = new Date();
    const isSameYear = date.getFullYear() === now.getFullYear();
    const options = { month: "long", day: "numeric" };
    return isSameYear
      ? date.toLocaleDateString("en-US", options)
      : date.toLocaleDateString("en-US", { ...options, year: "numeric" });
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row justify-between items-center p-4 border-y md:border border-separator md:rounded-md md:shadow-sm bg-background">
        <div>
          <Typography variant="h6" className="font-normal leading-none">
            Meal History
          </Typography>
        </div>
        <div className="flex flex-row gap-2">
          <Link to="/cookbook">
            <Button variant="contained" color="secondary" size="small" disableElevation className="text-primaryText">
              + Cook Now
            </Button>
          </Link>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        {recipeHistoryLoading ? (
          <div className="w-full p-4 border-y md:border border-separator rounded-lg bg-background">
            <Spinner />
          </div>
        ) : recipeHistoryError ? (
          <div className="w-full p-8 border-y md:border border-separator rounded-lg bg-background text-center">
            <Typography variant="subtitle1">
              Error fetching your meal history.<br></br>Please refresh the page and try again.
            </Typography>
          </div>
        ) : recipeHistory && recipeHistory?.length > 0 ? (
          recipeHistory.map((recipe, index) => {
            return <HistoryItem data={recipe} historyIndex={index} key={`history-${index}`} date={date} />;
          })
        ) : (
          <div className="w-full p-8 border-y md:border border-separator md:rounded-lg bg-background text-center">
            <Typography variant="subtitle1">You don't have anything logged for {formatDate(date)}.</Typography>
            <Link to="/cookbook">
              <Button variant="contained" color="secondary" disableElevation className="text-primaryText mt-4">
                <LinkIcon className="h-3 fill-secondaryText-600 mr-2" />
                Cook a recipe to add it!
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  insights: state.insights,
});

RecipeHistory.propTypes = {
  getRecipeHistory: PropTypes.func.isRequired,
  insights: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, { getRecipeHistory })(RecipeHistory);
